import { SalesforceReconnectBanner } from '@app/components/salesforce-reconnect-banner';
import { useFlags } from '@app/hooks/use-flags';
import React from 'react';

import { FLAG_ENABLE_CH_DASHBOARD_ANALYTICS } from '../../constants';
import { Charts } from './charts/charts';
import { MostEngagedAttendees } from './most-engaged-attendees/most-engaged-attendees';
import { MostViewedHubVideos } from './most-viewed-hub-videos/most-viewed-hub-videos';
import { MostVisitedEvents } from './most-visited-events/most-visited-events';

export const Overview = () => {
  const flags = useFlags();
  const enableCHDashboardAnalytics =
    flags?.[FLAG_ENABLE_CH_DASHBOARD_ANALYTICS];

  return (
    <div className="flex flex-col gap-6">
      <SalesforceReconnectBanner />
      <Charts />
      <div
        className={`grid gap-6 ${
          enableCHDashboardAnalytics ? 'grid-cols-3' : 'grid-cols-2'
        }`}
      >
        <MostVisitedEvents />
        <MostEngagedAttendees />
        {enableCHDashboardAnalytics && <MostViewedHubVideos />}
      </div>
    </div>
  );
};
